import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  HostListener,
  EventEmitter,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'app-combobox',
  templateUrl: './combobox.component.html',
  styleUrls: [
    './combobox.component.scss',
    '../dropdown/dropdown.component.scss'
  ]
})
export class ComboboxComponent implements OnInit, OnChanges {
  query;
  showingMenu = false;
  searching = false;
  hasBeenFiltered = false;
  originalOptions;
  selected;
  @Input() required: any;
  @Input() choice = {};
  @Input() key: any;
  @Input() label: any;
  @Input() options;
  @Output() selectedComboboxItem = new EventEmitter<Object>();
  @HostListener('document:click', ['$event.target']) public onClick(target) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.showingMenu = false;
      this.searching = false;
    }
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {}

  ngOnChanges(change: SimpleChanges) {
    if (change.options) {
      this.originalOptions = change.options.currentValue;
    }
  }

  showMenu = () => {
    this.searching = true;
    this.showingMenu = true;
  };

  select = (option) => {
    if (!this.hasBeenFiltered) {
      this.originalOptions = this.options;
    }
    this.choice = option;
    this.showingMenu = false;
    this.searching = false;
    this.query = '';
    this.selectedComboboxItem.emit(option);
    this.options = this.originalOptions;
  };

  onKey = (event) => {
    if (!this.searching) {
      this.query = null;
      return;
    }
    // always filter against the original set of options
    if (!this.hasBeenFiltered) {
      this.hasBeenFiltered = true;
      this.originalOptions = this.options;
    }
    this.options = this.originalOptions;

    // find options that match the query
    let filteredOptions = [];
    this.options.forEach((option) => {
      let value = option[this.key].toString().toLowerCase();
      if (value.includes(this.query.toLowerCase())) {
        filteredOptions.push(option);
      }
    });

    // dedupe options
    let uniqueOptions = [...new Set(filteredOptions)];
    this.options = uniqueOptions;
  };
}
